import React from "react";
import styled from "styled-components";
import { LanguageSwitcher } from "./LanguageSwitcher";
const Container = styled.div.withConfig({
  displayName: "FloatingLanguageSwitcher__Container",
  componentId: "sc-1twfh9q-0"
})(["position:fixed;right:0;top:0;"]);
export const FloatingLanguageSwitcher = () => {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(LanguageSwitcher, null));
};